import axios, { AxiosInstance } from 'axios';
import { APIService } from '../types/common';
import { addInterceptors } from '../utils/axiosInterceptors';

// creating axios private instances based on service here
const userServiceAPI: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_USER_SERVICE_PROD_API,
  withCredentials: true,
});

const financeServiceAPI: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_FINANCE_SERVICE_PROD_API,
  withCredentials: true,
});

const appointmentServiceAPI: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_APPOINTMENT_SERVICE_PROD_API,
  withCredentials: true,
});

// adding interceptors to services here
addInterceptors(userServiceAPI);
addInterceptors(financeServiceAPI);
addInterceptors(appointmentServiceAPI);

// function to get axios instance based on service declared here
export const getPrivateAxiosInstance = (whichService: APIService) => {
  switch (whichService) {
    case 'user':
      return userServiceAPI;

    case 'finance':
      return financeServiceAPI;

    case 'appointment':
      return appointmentServiceAPI;

    default:
      throw new Error('Invalid Service Type!!');
  }
};
